/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { __experimentalUnitControl as UnitControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import blockInfo from '../constants';

const { hookPrefix } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { maxWidth, stretchContainer } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'container',
						initialOpen: true,
						label: () => {
							return __( 'Container' );
						},
						cb: () => {
							return <>
								{ ! stretchContainer && <UnitControl
									label={ __( 'Max width' ) }
									help={ __( 'Set max width for the container' ) }
									value={ maxWidth }
									onChange={ ( value ) => {
										const data = { maxWidth: value };
										setAttributes( data );
									} }
								/> }
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
